import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="filters"
export default class extends Controller {
  static targets = [
    "templateCount", "staffCount", "departmentCount", "locationCount"
  ]

  connect() {
    // For the inline filters, we want to submit on change
    if (!this.isInSlideOver()) {
      this.element.addEventListener('change', this.submitForm.bind(this))
    }
    this.updateAllCounts()
    this.setupSelectAllAndClear()
  }

  disconnect() {
    if (!this.isInSlideOver()) {
      this.element.removeEventListener('change', this.submitForm.bind(this))
    }
  }

  submitForm() {
    // Add a small delay to ensure the select value is updated
    setTimeout(() => {
      this.element.requestSubmit()
    }, 100)
  }
  
  // Helper method to check if this controller is inside a slide-over
  isInSlideOver() {
    return this.element.closest('[data-controller="slide-over"]') !== null
  }

  // Setup event listeners for select all/clear links for each group
  setupSelectAllAndClear() {
    const groups = [
      { name: 'form_template_ids', countTarget: 'templateCount' },
      { name: 'staff_ids', countTarget: 'staffCount' },
      { name: 'department_ids', countTarget: 'departmentCount' },
      { name: 'location_ids', countTarget: 'locationCount' }
    ]
    groups.forEach(group => {
      // Select All
      this.element.querySelectorAll(`[data-group="${group.name}"] .select-all`).forEach(link => {
        link.addEventListener('click', e => {
          e.preventDefault()
          this.toggleAllCheckboxes(group.name, true)
        })
      })
      // Clear
      this.element.querySelectorAll(`[data-group="${group.name}"] .clear-all`).forEach(link => {
        link.addEventListener('click', e => {
          e.preventDefault()
          this.toggleAllCheckboxes(group.name, false)
        })
      })
    })
  }

  toggleAllCheckboxes(groupName, checked) {
    const checkboxes = this.element.querySelectorAll(`input[type=checkbox][name="${groupName}[]"]`)
    checkboxes.forEach(cb => { cb.checked = checked })
    this.updateCountForGroup(groupName)
  }

  updateAllCounts() {
    this.updateCountForGroup('form_template_ids')
    this.updateCountForGroup('staff_ids')
    this.updateCountForGroup('department_ids')
    this.updateCountForGroup('location_ids')
  }

  updateCountForGroup(groupName) {
    const checkboxes = this.element.querySelectorAll(`input[type=checkbox][name="${groupName}[]"]`)
    const checkedCount = Array.from(checkboxes).filter(cb => cb.checked).length
    const totalCount = checkboxes.length
    let countTarget = null
    switch (groupName) {
      case 'form_template_ids': countTarget = this.hasTemplateCountTarget ? this.templateCountTarget : null; break;
      case 'staff_ids': countTarget = this.hasStaffCountTarget ? this.staffCountTarget : null; break;
      case 'department_ids': countTarget = this.hasDepartmentCountTarget ? this.departmentCountTarget : null; break;
      case 'location_ids': countTarget = this.hasLocationCountTarget ? this.locationCountTarget : null; break;
    }
    if (countTarget) {
      countTarget.textContent = `${checkedCount} of ${totalCount} selected`
    }
  }
}
